export const IdccIterim = ['1413', '2378'] as const
export type IdccIterim = typeof IdccIterim[number]

/** Sous Idcc disponible à la créations */
export const IdccIterimDisponible = [...IdccIterim] as const
export type IdccIterimDisponible = typeof IdccIterimDisponible[number]